/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_reinsurances_free_of_charge = /** @type {(inputs: {}) => string} */ () => {
	return `Bez poplatků`
};

const da_reinsurances_free_of_charge = /** @type {(inputs: {}) => string} */ () => {
	return `Gratis`
};

const de_reinsurances_free_of_charge = /** @type {(inputs: {}) => string} */ () => {
	return `Kostenlos`
};

const en_reinsurances_free_of_charge = /** @type {(inputs: {}) => string} */ () => {
	return `Free of charge`
};

const es_reinsurances_free_of_charge = /** @type {(inputs: {}) => string} */ () => {
	return `Sin cargos`
};

const fr_reinsurances_free_of_charge = /** @type {(inputs: {}) => string} */ () => {
	return `Sans frais`
};

const hu_reinsurances_free_of_charge = /** @type {(inputs: {}) => string} */ () => {
	return `Díjmentes`
};

const it_reinsurances_free_of_charge = /** @type {(inputs: {}) => string} */ () => {
	return `Senza costi aggiuntivi`
};

const nl_reinsurances_free_of_charge = /** @type {(inputs: {}) => string} */ () => {
	return `Gratis`
};

const pl_reinsurances_free_of_charge = /** @type {(inputs: {}) => string} */ () => {
	return `Bez opłat`
};

const pt_reinsurances_free_of_charge = /** @type {(inputs: {}) => string} */ () => {
	return `Sem taxas`
};

const sv_reinsurances_free_of_charge = /** @type {(inputs: {}) => string} */ () => {
	return `Avgiftsfritt`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const reinsurances_free_of_charge = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.reinsurances_free_of_charge(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("reinsurances_free_of_charge", locale)
	if (locale === "cs") return cs_reinsurances_free_of_charge(inputs)
	if (locale === "da") return da_reinsurances_free_of_charge(inputs)
	if (locale === "de") return de_reinsurances_free_of_charge(inputs)
	if (locale === "en") return en_reinsurances_free_of_charge(inputs)
	if (locale === "es") return es_reinsurances_free_of_charge(inputs)
	if (locale === "fr") return fr_reinsurances_free_of_charge(inputs)
	if (locale === "hu") return hu_reinsurances_free_of_charge(inputs)
	if (locale === "it") return it_reinsurances_free_of_charge(inputs)
	if (locale === "nl") return nl_reinsurances_free_of_charge(inputs)
	if (locale === "pl") return pl_reinsurances_free_of_charge(inputs)
	if (locale === "pt") return pt_reinsurances_free_of_charge(inputs)
	return sv_reinsurances_free_of_charge(inputs)
};
export { reinsurances_free_of_charge as "reinsurances.free_of_charge" }